export class UnitReminder {
  constructor(retirement_unit?: string, uom_reminder?: string) {
    this.retirement_unit = retirement_unit;
    this.uom_reminder = uom_reminder;
  }
  retirement_unit: string;
  uom_reminder: string;
}
